import * as types from 'constants/ActionTypes';

const addressInfoInit = {
  firstName: '',
  lastName: '',
  company: '',
  emailAddress: '',
  emailCC: '',
  country: '',
  department: '',
  phone: '',
  phoneExt: '',
  secondaryPhone: '',
  secondaryExt: '',
  address1: '',
  city: '',
  state: '',
  zip: '',
};

const initState = {
  loading: false,
  companyLogo: {
    fileDescription: '',
    fileData: '',
  },
  addressInfo: {
    firstName: '',
    lastName: '',
    company: '',
    emailAddress: '',
    marketingEmails: false,
    emailCC: '',
    country: '',
    department: '',
    phone: '',
    phoneExt: '',
    secondaryPhone: '',
    secondaryExt: '',
    address1: '',
    city: '',
    state: '',
    zip: '',
  },
  isAddressInfoUpdated: false,
  submitAddressInfo: {
    showMessage: false,
    errorMessage: null,
  },
  addressInfoErrors: addressInfoInit,
};

export default (state = initState, action = {}) => {
  switch (action.type) {
    case types.LOAD_CONTACT_INFO_START: return { ...state, loading: true };
    case types.LOAD_CONTACT_INFO_SUCCESS: return { ...state, loading: false };
    case types.LOAD_CONTACT_INFO_ERROR: {
      return { ...state, loading: false };
    }
    case types.CONTACT_INFO_LOAD_ADDRESS_INFO: return { ...state, addressInfo: { ...state.addressInfo, ...action.addressInfo } };
    case types.CONTACT_INFO_LOAD_COMPANY_LOGO: return { ...state, companyLogo: { ...action.companyLogo } };
    case types.CONTACT_INFO_LOAD_COMPANY_LOGO_ERROR: return { ...state, islogoLoadError: true, loading: false };
    case types.CONTACT_INFO_UPDATE_ADDRESS_INFO: {
      const addressInfoUpdated = { ...state.addressInfo };
      addressInfoUpdated[action.fieldId] = action.fieldId === 'marketingEmails' ? Boolean(action.value) : (action.value || '');
      return {
        ...state,
        addressInfo: { ...addressInfoUpdated },
        isAddressInfoUpdated: true,
      };
    }
    case types.CONTACT_INFO_UPDATE_ADDRESS_INFO_FIELDS: {
      return {
        ...state,
        addressInfo: { ...action.addressInfo },
        isAddressInfoUpdated: false,
      };
    }
    case types.CONTACT_INFO_SUBMIT_START: return { ...state, loading: true };
    case types.CONTACT_INFO_RESET_PAGE: return initState;
    case types.CONTACT_INFO_SUBMIT_COMPLETE: return {
      ...state,
      loading: false,
      submitAddressInfo: { ...state.submitAddressInfo, showMessage: true, errorMessage: null },
    };
    case types.CONTACT_INFO_SUBMIT_ERROR: return {
      ...state,
      loading: false,
      submitAddressInfo: { ...state.submitAddressInfo, showMessage: true, errorMessage: action.errorMessage },
    };
    case types.CONTACT_INFO_SUBMIT_VALIDATION_ERROR: return {
      ...state,
      loading: false,
    };
    case types.CONTACT_INFO_SHOW_ADDRESS_VALIDATION_ERRORS: return {
      ...state,
      addressInfoErrors: { ...state.addressInfoErrors, ...action.validationError },
      submitAddressInfo: { ...state.submitAddressInfo, showMessage: false, errorMessage: null },
    };
    case types.CONTACT_INFO_RESET_ADDRESS_VALIDATION_ERRORS: return {
      ...state,
      addressInfoErrors: addressInfoInit,
    };
    case types.CONTACT_INFO_SUBMIT_RESET: return { ...state, submitAddressInfo: { ...initState.submitAddressInfo, showMessage: false } };
    default: return state;
  }
};
